import { render, staticRenderFns } from "./SectionSizes.vue?vue&type=template&id=71b43342&scoped=true&"
import script from "./SectionSizes.vue?vue&type=script&lang=js&"
export * from "./SectionSizes.vue?vue&type=script&lang=js&"
import style0 from "./SectionSizes.vue?vue&type=style&index=0&id=71b43342&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b43342",
  null
  
)

export default component.exports